@if (!!violations && !stats) {
  <div class="violations">
    @if (showStats) {
      <div class="violation-count">{{
          filteredViolations.length | i18nPlural: {
            '=0': 'No violations',
            '=1': '1 violation',
            'other': '# violations'
          }
        }} ({{ violations.length - filteredViolations.length }} filtered)
      </div>
    }
    <p-accordion class="violation-list flex" (onClose)="activeTarget = undefined;" (onOpen)="activeTarget = undefined;">
      @for (violation of filteredViolations; track i; let i = $index) {
        <p-accordion-panel [value]="i">
          <p-accordion-header [style]="{'display': 'flex'}">
            <div class="title">{{ violation.help }}</div>
          </p-accordion-header>
          <p-accordion-content>
            <div class="violation">
              <div class="nodes-container">
                @for (node of violation.nodes; track nodeIdx; let nodeIdx = $index) {
                  <div class="nodes">
                    @for (target of node.target; track idx; let idx = $index) {
                      <div class="targets">
                        <div class="target" [ngClass]="{'active': activeTarget?.target.toString() === target.toString()}">
                          <fa-icon [icon]="faInfoSquare" (mouseover)="highlightObservation(violation, node, target);" (mouseout)="resetHighlightToActiveElement()" (click)="showObservation(violation, node, target)"></fa-icon>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              @if (!!activeTarget) {
                <div class="details">
                  <div class="actions">
                    @if (needAddToFindingsButton) {
                      <button pButton class="add-to-finding-btn" icon="true" label="Add to Finding" (click)="emitAddObservation()">
                        <img class="add-finding-icon" src="assets/img/corpus-delicti.svg"/>
                      </button>
                    }
                  </div>
                  <div class="form-section no-infos node-info">
                    <div class="form-section-content flex">
                      <div class="form-item">
                        <label class="form-label">WCAG Mapping</label>
                        <div class="wcag-mapping">
                          @for (label of violation.tags; track labelIdx; let labelIdx = $index) {
                            <div class="wcag-label">{{ label }}</div>
                          }
                        </div>
                      </div>
                      <div class="form-item">
                        <label class="form-label">Description</label>
                        <div class="description" [innerHTML]="activeTargetFailureSummary"></div>
                      </div>
                      <div class="form-item">
                        <label class="form-label">Selector</label>
                        <div class="target">
                          <pre><code>{{ activeTarget.target }}</code></pre>
                        </div>
                      </div>
                      <div class="form-item">
                        <label class="form-label">HTML</label>
                        <div class="html">
                          <pre><code>{{ activeTarget['html'] }}</code></pre>
                        </div>
                      </div>
                      @if (!!activeElement) {
                        <div class="screenshot form-item">
                          <label class="form-label">Screenshot</label>
                          @if (!!activeElement.elementScreenshot) {
                            <wm-image [imageId]="activeElement.elementScreenshot" [infoItems]="activeElementStateInfos || []"
                                      [allowToOpenScreenshotToolInPopup]="true"></wm-image>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
}
<div class="screenshot-area">

</div>
